import React, { useEffect, useState } from "react";
import { BackTop, Modal, Button,Checkbox } from "antd";
// import Joyride, { STATUS } from "react-joyride";
// import { Link } from "react-router-dom";

import AdHelper from "../shared/ad/AdHelper";
import HomeNavigation from "../navigation/HomeNavigation";
// import VimeoVideo from "../video/VimeoVideo";
// import VimeoChat from "../video/VimeoChat";
// import CandidatePreview from "../candidate/CandidatePreview";
import { useLoading, useGuideData } from "../../hooks";


 // Function to get a cookie by name 
 const getCookie = (name) => {
  const cookies = document.cookie.split("; ");
  const cookie = cookies.find((row) => row.startsWith(name + "="));
  console.log(cookie)
  return cookie ? cookie.split("=")[1]: null;
}

// Function to set a cookie
const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000); // Convert days to milliseconds
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Strict`;
};

const HomePage = (props) => {
  const [inProgress, setProgress] = useState(false);
  const { isLoading } = useLoading();
  const [isReady, setIsReady] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [showPreferencesModal, setShowPreferencesModal] = useState(false);
  const [cookiePreferences, setCookiePreferences] = useState({
    analytics: true,
    marketing: true,
  });

  // hardcoded live streaming candidate example
  // const liveStreamer = {
  //   bio: {
  //     profileImage:
  //       "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Kamala_Harris_official_photo_%28cropped2%29.jpg/220px-Kamala_Harris_official_photo_%28cropped2%29.jpg",
  //     name: "Kamala Devi Harris",
  //     rating: {
  //       total: 1,
  //       stars: 5,
  //     },
  //     office: {
  //       incumbent: {
  //         state: "Florida",
  //         city: "Miami Beach",
  //         title: "Senator",
  //       },
  //       ballot: {
  //         title: "Vice President of United States",
  //       },
  //       party: "Democratic Party",
  //     },
  //     contact: {
  //       address: "112 Hart Senate Office Building, Washington, DC, 20510",
  //       phone: "202-224-3553",
  //     },
  //     social: {
  //       facebook: "https://www.facebook.com/SenatorKamalaHarris/",
  //       youtube: "https://www.youtube.com/channel/UCe1ciA1TDa5F9K6Ufr_6Fsw",
  //       twitter: "https://twitter.com/SenKamalaHarris",
  //       instagram: "https://www.instagram.com/kamalaharris/?hl=en",
  //       website: "https://www.harris.senate.gov/",
  //     },
  //     general: {
  //       comments: [],
  //     },
  //     political: {
  //       experience: "Senator, United States Senate, California, 2017-present",
  //       comments: [
  //         {
  //           comment: "yes, she is a senator",
  //           userId: "testUser",
  //           status: "pending",
  //           date: "26/08/2020",
  //           candidateId: "5f502c781eed5bbe2409f790",
  //           section: "political",
  //           up: 0,
  //           down: 0,
  //         },
  //       ],
  //     },
  //     personal: {
  //       comments: [],
  //       gender: "female",
  //       family: "Husband: Doug; 2 Step-Children: Ella, Cole",
  //       birthdate: "10/20/1964",
  //       education:
  //         "JD, University of California, Hastings College of the Law, 1990",
  //       religion: "Baptist",
  //       homeCity: "San Francisco, CA",
  //     },
  //     professional: {
  //       experience: "Deputy District Attorney, Alameda County, 1990-1998",
  //       comments: [],
  //     },
  //     other: {
  //       experience: "Vice President, National District Attorneys Association",
  //       comments: [],
  //     },
  //     committee: {
  //       experience:
  //         "Former Member, Subcommittee on Surface Transportation and Merchant Marine Infrastructure, Safety, and Security, United States Senate",
  //       comments: [],
  //     },
  //   },
  //   positions: [
  //     {
  //       topic: "Abortion & Reproductive",
  //       position:
  //         "Kamala Harris has been a champion for a woman's right to choose and access to comprehensive reproductive health care throughout her entire career.",
  //       comments: [
  //         {
  //           comment: "test comment #1",
  //           userId: "testUser",
  //           status: "pending",
  //           date: "26/08/2020",
  //           candidateId: "5f502c781eed5bbe2409f790",
  //           section: "Abortion & Reproductive",
  //           up: 0,
  //           down: 0,
  //         },
  //         {
  //           comment: "test comment #2",
  //           userId: "testUser",
  //           status: "pending",
  //           date: "26/08/2020",
  //           candidateId: "5f502c781eed5bbe2409f790",
  //           section: "Abortion & Reproductive",
  //           up: 0,
  //           down: 0,
  //         },
  //         {
  //           comment: "test comment #6",
  //           userId: "testUser",
  //           status: "pending",
  //           date: "26/08/2020",
  //           candidateId: "5f502c781eed5bbe2409f790",
  //           section: "Abortion & Reproductive",
  //           up: 0,
  //           down: 0,
  //         },
  //       ],
  //     },
  //     {
  //       topic: "Budget, Spending & Taxes",
  //       position:
  //         "Instead of giving America's most fortunate more tax breaks, let's ask them to make a contribution a little bit more to help invest in infrastructure, job training, and making college affordable.",
  //       comments: [
  //         {
  //           comment: "test comment #3",
  //           userId: "testUser",
  //           status: "pending",
  //           date: "26/08/2020",
  //           candidateId: "5f502c781eed5bbe2409f790",
  //           section: "Budget, Spending & Taxes",
  //           up: 0,
  //           down: 0,
  //         },
  //         {
  //           comment: "test comment #4",
  //           userId: "testUser",
  //           status: "pending",
  //           date: "26/08/2020",
  //           candidateId: "5f502c781eed5bbe2409f790",
  //           section: "Budget, Spending & Taxes",
  //           up: 0,
  //           down: 0,
  //         },
  //         {
  //           comment: "test comment #5",
  //           userId: "testUser",
  //           status: "pending",
  //           date: "26/08/2020",
  //           candidateId: "5f502c781eed5bbe2409f790",
  //           section: "Budget, Spending & Taxes",
  //           up: 0,
  //           down: 0,
  //         },
  //         {
  //           comment: "",
  //           userId: "testUser",
  //           status: "pending",
  //           date: "26/08/2020",
  //           candidateId: "5f502c781eed5bbe2409f790",
  //           section: "Budget, Spending & Taxes",
  //           up: 0,
  //           down: 0,
  //         },
  //         {
  //           comment: "",
  //           userId: "testUser",
  //           status: "pending",
  //           date: "26/08/2020",
  //           candidateId: "5f502c781eed5bbe2409f790",
  //           section: "Budget, Spending & Taxes",
  //           up: 0,
  //           down: 0,
  //         },
  //       ],
  //     },
  //   ],
  //   questions: [
  //     {
  //       question: "new test question 3 for Kamala",
  //       user: "testUser",
  //       status: "pending",
  //       answers: [
  //         {
  //           user: "testabcd",
  //           candidate_id: {
  //             $oid: "5f502c781eed5bbe2409f790",
  //           },
  //           questionIndex: 0,
  //           answer: "reply to question 3 for Kamala",
  //           date: "11/08/2020",
  //         },
  //       ],
  //       date: "20/08/2020",
  //       candidateId: "5f502c781eed5bbe2409f790",
  //     },
  //     {
  //       question: "new test question 4 for Kamala",
  //       user: "testUser",
  //       status: "pending",
  //       answers: [
  //         {
  //           user: "testabcd",
  //           candidate_id: {
  //             $oid: "5f502c781eed5bbe2409f790",
  //           },
  //           questionIndex: 1,
  //           answer: "reply to test question 4 for kamala",
  //           date: "11/08/2020",
  //         },
  //       ],
  //       date: "20/08/2020",
  //       candidateId: "5f502c781eed5bbe2409f790",
  //     },
  //     {
  //       question: "New Test Question for Kamala",
  //       user: "testUser",
  //       status: "pending",
  //       answers: [
  //         {
  //           user: "testabcd",
  //           candidate_id: {
  //             $oid: "5f502c781eed5bbe2409f790",
  //           },
  //           questionIndex: 2,
  //           answer: "reply to test question for kamala",
  //           date: "11/08/2020",
  //         },
  //       ],
  //       date: "20/08/2020",
  //       candidateId: "5f502c781eed5bbe2409f790",
  //     },
  //     {
  //       question: "happy",
  //       user: "testUser",
  //       status: "pending",
  //       answers: [],
  //       date: "20/08/2020",
  //       candidateId: "5f502c781eed5bbe2409f790",
  //     },
  //     {
  //       question: "fdfdfs\n",
  //       user: "testUser",
  //       status: "pending",
  //       answers: [],
  //       date: "20/08/2020",
  //       candidateId: "5f502c781eed5bbe2409f790",
  //     },
  //     {
  //       question: "",
  //       user: "testUser",
  //       status: "pending",
  //       answers: [],
  //       date: "20/08/2020",
  //       candidateId: "5f502c781eed5bbe2409f790",
  //     },
  //   ],
  //   updates: [
  //     {
  //       date: "10/09/2020",
  //       description:
  //         "Harris, Leahy, Booker Press Chairman Graham Not To Conduct Supreme Court Hearings Without COVID-19 Testing Procedures In Place",
  //     },
  //     {
  //       description:
  //         "Harris, Brown Introduce Heat Stress Legislation to Protect Workers",
  //       date: "10/01/2020",
  //     },
  //   ],
  //   legislation: [
  //     {
  //       bill: "S4",
  //       vote: "Other",
  //       name_description:
  //         "Coronavirus Aid, Relief, and Economic Security Act (CARES Act)",
  //       key: "1",
  //       summary:
  //         "This bill is to protect the healthcare of hundreds of millions of people of the United States and prevent efforts of the Department of Justice to advocate courts to strike down the Patient Protection and Affordable Care Act.",
  //     },
  //     {
  //       key: "2",
  //       bill: "H.R.1957",
  //       vote: "Yea",
  //       name_description: "Taxpayer First Act of 2019",
  //       summary:
  //         "This bill establishes the National Parks and Public Land Legacy Restoration Fund to support deferred maintenance projects on federal land.",
  //     },
  //     {
  //       key: "3",
  //       bill: "H.R.748",
  //       vote: "Nay",
  //       name_description: "Middle Class Health Benefits Tax Repeal Act of 2019",
  //       summary:
  //         "Amendment SA 1577, under the order of 3/25/20, not having achieved 60 votes in the affirmative, was S.Amdt.1577 RC# 79",
  //     },
  //     {
  //       key: "4",
  //       bill: "S.4",
  //       vote: "Sponsored",
  //       name_description: "(no name for now)",
  //       summary:
  //         "This bill is to direct Occupational Safety and Health Administration (OSHA) to issue an occupational safety and health standard to protect workers from heat-related injuries and illnesses.",
  //     },
  //   ],
  //   archived: true,
  // };


  const tutorialSteps = [
    {
      target: ".tutorial-navigation",
      content: "Navigation for homepage, scrollable in mobile",
      title: "Navigation",
      disableBeacon: true,
    },
    {
      target: ".tutorial-nav-elections",
      content: "Elections list with candidates involved",
      title: "Elections",
    },
    {
      target: ".tutorial-nav-candidates",
      content: "Candidates list with their profiles and details",
      title: "Navigation",
    },
    {
      target: ".tutorial-nav-coalitions",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce tincidunt erat id quam pulvinar, in convallis neque auctor. ",
      title: "Navigation",
    },
    {
      target: ".tutorial-nav-organizations",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce tincidunt erat id quam pulvinar, in convallis neque auctor. ",
      title: "Navigation",
    },
    {
      target: ".tutorial-nav-movements",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce tincidunt erat id quam pulvinar, in convallis neque auctor. ",
      title: "Navigation",
    },
    {
      target: ".tutorial-nav-services",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce tincidunt erat id quam pulvinar, in convallis neque auctor. ",
      title: "Navigation",
    },
    {
      target: ".tutorial-body",
      content:
        "This is where you will see all elections and candidates details.",
    },
  ];

  // const { updateUserGuide, runJoyRideStep } = useGuideData();

  // function handleJoyrideCallback(data) {
  //   const { status } = data;
  //   if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
  //     updateUserGuide("home-nav");
  //   }
  // }

  const questions = [
    "Did you know that the Congressional Budget Office stated the 2025 One Big Beautiful Bill will add over $3.3 trillion to the national debt?",
    "Did you know that Georgia and Wyoming have the lowest minimum wage at $5.15 per hour?",
    "Did you know that income, payroll, and corporate taxes are the largest revenue sources of the U.S. federal government?"
  ]

  useEffect(() => {
    try {
      const analyticsCookie = getCookie("analytics_cookies");
      const marketingCookie = getCookie("marketing_cookies");
      showModal();
  
      if (!getCookie("cookie_consent")) {
        setShowCookieBanner(true);
      }
  
      setCookiePreferences({
        analytics: analyticsCookie !== null ? analyticsCookie === "true" : true,
        marketing: marketingCookie !== null ? marketingCookie === "true" : true,
      });
  
      // After all initialization complete
      setIsReady(true);
    } catch (err) {
      console.error("Initialization failed", err);
      setIsReady(true); // allow page to render even if something failed
    }
  }, []); // eslint-disable-line

  const handleClose = () => {
    setIsModalVisible(false);
  };



  const showModal = () => {
   
    const randomQuestion = questions[Math.floor(Math.random()* questions.length)];
    setCurrentQuestion(randomQuestion);
    setIsModalVisible(true);

  }

  const handleAnswer = (answer) => {
    setIsModalVisible(false);
    console.log(answer)
  }

  // Handle cookie consent actions

  const handleAccept = () => {
    setCookie("cookie_consent", "accepted", 365); //Save consent for 1 year
    console.log("Cookies accepted")
    setShowCookieBanner(false);
  }

  const handleManagePreferences = () => {
    console.log("Managing cookie preferences...");
    setShowPreferencesModal(true);
  };

  // Handle Reject All
  const handleReject = () => {
    setCookie("cookie_consent", "rejected", 365);
    setCookie("analytics_cookies", "false", 365);
    setCookie("marketing_cookies", "false", 365);
    setShowCookieBanner(false);
  };

  // Save Preferences
  const handleSavePreferences = () => {
    setCookie("analytics_cookies", cookiePreferences.analytics, 365);
    setCookie("marketing_cookies", cookiePreferences.marketing, 365);
    setCookie("cookie_consent", "custom", 365);
    if (!cookiePreferences.analytics) {
      document.cookie = "analytics_cookies=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      window[`ga-disable-UA-XXXXXXX`] = true; // Disable Google Analytics
    }
  
    if (!cookiePreferences.marketing) {
      document.cookie = "marketing_cookies=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.querySelectorAll("script[data-marketing]").forEach((script) => {
        script.remove(); // Remove marketing scripts
      });
    }
    setShowCookieBanner(false);
    setShowPreferencesModal(false);
  };





  return (
      <>
        {isReady ? (
          <>
            <AdHelper page="home-top" />
            <HomeNavigation
              coordinates={props.coordinates}
              userLocation={props.userLocation}
              divisions={props.divisions}
            />
    
            <Modal
              title="Welcome"
              open={isModalVisible}
              centered
              onCancel={handleClose}
              footer={[
                <Button key="close" onClick={handleClose}>Close</Button>
              ]}
            >
              <p>{currentQuestion}</p>
              <div style={{ marginTop: 16 }}>
                <Button type="primary" onClick={() => handleAnswer("Yes")}>Yes</Button>
                <Button style={{ marginLeft: 8 }} onClick={() => handleAnswer("No")}>No</Button>
              </div>
            </Modal>
    
            {showCookieBanner && (
              <div style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                backgroundColor: '#f8f8f8',
                padding: '25px 20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)',
                zIndex: 1000,
              }}>
                <p style={{
                  fontSize: '16px',
                  color: '#333',
                  marginBottom: '15px',
                  maxWidth: '800px'
                }}>
                  We use cookies to enhance your experience, analyze site usage, and assist in our marketing efforts.
                </p>
                <div style={{
                  display: 'flex',
                  gap: '15px',
                  flexWrap: 'wrap',
                  justifyContent: 'right'
                }}>
                  <Button type="primary" onClick={handleAccept} style={{ height: '40px', fontSize: '14px' }}>Accept All</Button>
                  <Button onClick={handleManagePreferences} style={{ height: '40px', fontSize: '14px' }}>Manage Preferences</Button>
                  <Button danger onClick={handleReject} style={{ height: '40px', fontSize: '14px' }}>Reject</Button>
                </div>
              </div>
            )}
    
            <Modal
              title="Manage Cookie Preferences"
              open={showPreferencesModal}
              centered
              onCancel={() => setShowPreferencesModal(false)}
              footer={[
                <Button key="cancel" onClick={() => setShowPreferencesModal(false)}>Cancel</Button>,
                <Button key="save" type="primary" onClick={handleSavePreferences}>Save Preferences</Button>
              ]}
            >
              <p>Choose which cookies you would like to allow:</p>
              <Checkbox
                checked={cookiePreferences.analytics}
                onChange={(e) => setCookiePreferences({ ...cookiePreferences, analytics: e.target.checked })}
              >
                Allow Analytics Cookies
              </Checkbox>
              <br />
              <Checkbox
                checked={cookiePreferences.marketing}
                onChange={(e) => setCookiePreferences({ ...cookiePreferences, marketing: e.target.checked })}
              >
                Allow Marketing Cookies
              </Checkbox>
            </Modal>
    
            <div className="inner lead" style={{ textAlign: "center" }}>
              <h2>ABOUT US</h2>
              <p style={{ 
                display: "inline-block", 
                textAlign: "center",
                maxWidth: "600px",
                lineHeight: "1.8"
              }}>
                <strong>No Cap = No Lies</strong><br />
                No Cap, we're taking it back, old school vibes.<br />
                It's about the person behind the platform,<br />
                not the pitch.<br />
                The clearest insight into a person comes from<br />
                life experiences that shaped their values and guide<br />
                the way they act, serve, or lead.<br />
                Understanding the person behind the platform<br />
                allows others to make thoughtful, informed decisions.
              </p>
            </div>
    
            <BackTop />
          </>
        ) : (
          <div style={{ padding: '50px', textAlign: 'center' }}>
            <p>Loading homepage...</p>
          </div>
        )}
      </>
    );

        }

export default HomePage;
